export interface PartnerPracticeAddress {
    id?: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    addressLine3: string | null;
    town: string | null;
    county: string | null;
    postcode: string | null;
    version?: number;
}

export function createPartnerPracticeAddress(): PartnerPracticeAddress {
    return {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        town: '',
        county: '',
        postcode: '',
    };
}
